module.exports = __webpack_public_path__ + "PinkNannies-Circle.svg?15f79471eac73fffb57bd540f9e741fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/PinkNannies-Circle.svg
// module id = 599
// module chunks = 0